<!--
  Rejilla de 24. Trazo 1.75, remates y uniones redondos, `currentColor`.
  El punto sólido (`fill`) se reserva para lo que ES un punto —el centro de un
  aviso, la marca de un paso—, nunca como relleno decorativo.
-->
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
  stroke-linecap="round" stroke-linejoin="round" focusable="false">
  @switch (name) {

    <!-- ---- Estado y validación ---- -->
    @case ('check-circle') {
      <circle cx="12" cy="12" r="9" />
      <path d="m8.25 12.25 2.5 2.5 5-5.5" />
    }
    @case ('alert-circle') {
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.75v4.75" />
      <circle cx="12" cy="16.1" r="1" fill="currentColor" stroke="none" />
    }
    @case ('x-circle') {
      <circle cx="12" cy="12" r="9" />
      <path d="m9.25 9.25 5.5 5.5M14.75 9.25l-5.5 5.5" />
    }
    @case ('minus-circle') {
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 12h7" />
    }
    @case ('info') {
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16.25V11.5" />
      <circle cx="12" cy="8" r="1" fill="currentColor" stroke="none" />
    }
    @case ('help') {
      <!-- Ayuda: el círculo de `info` con la interrogación. Abre las novedades
           y el recorrido de la vista desde la barra superior. -->
      <circle cx="12" cy="12" r="9" />
      <path d="M9.6 9.4a2.5 2.5 0 0 1 4.85.85c0 1.65-2.45 2.2-2.45 3.75" />
      <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" />
    }
    @case ('check') {
      <path d="m5 12.5 4.5 4.5L19 7" />
    }
    <!-- Recargar: el lazo se cierra en sentido horario y la cabeza marca por
         dónde sigue. Acción genérica, como download o upload: no hay una cosa
         del dominio que dibujar aquí. -->
    @case ('refresh') {
      <path d="M19.3 12A7.3 7.3 0 1 1 15.65 5.68" />
      <path d="M12.75 5.68 15.65 5.68 14.2 3.17" />
    }

    <!-- ---- Acciones ---- -->
    @case ('pencil') {
      <path d="M4.5 19.5h3.2l9-9a2.26 2.26 0 0 0-3.2-3.2l-9 9z" />
      <path d="m13.1 8.4 2.5 2.5" />
    }
    @case ('plus') {
      <path d="M12 5.5v13M5.5 12h13" />
    }
    @case ('minus') {
      <path d="M5.5 12h13" />
    }
    <!-- Encuadrar: las cuatro esquinas de un marco, para «ver la ruta completa». -->
    @case ('encuadrar') {
      <path d="M4.75 9V5.75a1 1 0 0 1 1-1H9M15 4.75h3.25a1 1 0 0 1 1 1V9M19.25 15v3.25a1 1 0 0 1-1 1H15M9 19.25H5.75a1 1 0 0 1-1-1V15" />
    }
    @case ('trash') {
      <path d="M4.75 7h14.5M9.5 7V5.25h5V7" />
      <path d="M6.5 7l.85 11.1a1.5 1.5 0 0 0 1.5 1.4h6.3a1.5 1.5 0 0 0 1.5-1.4L17.5 7" />
      <path d="M10.4 10.6v5.6M13.6 10.6v5.6" />
    }
    @case ('download') {
      <path d="M12 4.5v10" />
      <path d="m8.25 11 3.75 3.75L15.75 11" />
      <path d="M5 17.5v1.25a.75.75 0 0 0 .75.75h12.5a.75.75 0 0 0 .75-.75V17.5" />
    }
    @case ('upload') {
      <path d="M12 14.75v-10" />
      <path d="m8.25 8.25 3.75-3.5 3.75 3.5" />
      <path d="M5 17.5v1.25a.75.75 0 0 0 .75.75h12.5a.75.75 0 0 0 .75-.75V17.5" />
    }
    @case ('copy') {
      <rect x="9" y="9" width="10.5" height="10.5" rx="2" />
      <path d="M15 9V6.5a2 2 0 0 0-2-2H6.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H9" />
    }
    @case ('search') {
      <circle cx="10.75" cy="10.75" r="6.25" />
      <path d="m15.4 15.4 4.1 4.1" />
    }
    @case ('send') {
      <path d="M20 4 10.5 13.5" />
      <path d="M20 4l-6.2 16-3.3-6.5L4 10.2z" />
    }
    @case ('close') {
      <path d="m6.5 6.5 11 11M17.5 6.5l-11 11" />
    }

    <!-- ---- Navegación ---- -->
    @case ('chevron-down') {
      <path d="m6.5 9.5 5.5 5.5 5.5-5.5" />
    }
    @case ('chevron-up') {
      <path d="m6.5 14.5 5.5-5.5 5.5 5.5" />
    }
    @case ('chevron-right') {
      <path d="m9.5 6.5 5.5 5.5-5.5 5.5" />
    }
    @case ('arrow-left') {
      <path d="M19 12H5.5" />
      <path d="m11 5.5-5.5 6.5 5.5 6.5" />
    }
    @case ('more-vertical') {
      <circle cx="12" cy="5.75" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <circle cx="12" cy="18.25" r="1.4" fill="currentColor" stroke="none" />
    }
    <!-- Menú: los tres raíles. Es de los pocos dibujos que NO se derivan del
         dominio, y por la misma razón que `close` o `more-vertical`: no hay una
         cosa del negocio que dibujar aquí — es una afordancia de la interfaz, y
         una que el usuario ya tiene aprendida. Inventarle un dibujo propio la
         haría peor, no más nuestra. -->
    @case ('menu') {
      <path d="M4.5 7.25h15M4.5 12h15M4.5 16.75h15" />
    }

    <!-- ---- Objetos del dominio ---- -->
    @case ('document') {
      <path d="M13.5 3.75H7a2 2 0 0 0-2 2v12.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9.25z" />
      <path d="M13.5 3.75V9.25H19" />
      <path d="M8.75 13.5h6.5M8.75 16.5h4.5" />
    }
    <!-- Borrador: la hoja que todavía se está escribiendo. La familia de la hoja
         ya tiene tres miembros —`document` cualquiera, `certificado` el sellado,
         `documento-adjunto` el anexo— y los tres comparten la silueta con la
         esquina doblada; lo que varía es qué la convierte en ESA hoja. Aquí es
         el lápiz, y va fuera de la hoja, solapando su esquina inferior derecha,
         por lo mismo que el sello de `certificado`: dentro, a 17px, se funde con
         los renglones. Sustituye a `far fa-file-alt`, que servía igual para un
         borrador que para un manual. -->
    @case ('borrador') {
      <path d="M5.1 3.5h6l3.4 3.4v6.3a1.5 1.5 0 0 1-1.5 1.5H5.1a1.5 1.5 0 0 1-1.5-1.5V5a1.5 1.5 0 0 1 1.5-1.5z" />
      <path d="M10.9 3.6v3.4h3.5" />
      <path d="M6.4 9.4h4.2M6.4 11.9h2.5" />
      <path d="m18.1 12.7 2.4 2.4-5.8 5.8-3.2.8.8-3.2z" />
      <path d="m16.3 14.5 2.4 2.4" />
    }
    <!-- Factura: la hoja con la fila del total rellena. Lo que distingue a una
         factura de cualquier otra hoja es que termina en una cifra, y el peso
         sólido es lo único que sobrevive a 17px — la misma razón por la que el
         rayo de `pronto-pago` va relleno y el sello de `certificado` también.

         Se descartaron dos versiones, las dos medidas y no juzgadas a ojo. La
         hoja con el signo de moneda: su vecino en la barra es `pronto-pago`,
         que ya lleva el billete, y dos glifos de dinero seguidos en la misma
         columna no se distinguen. Y la hoja con el canto desgarrado, que a 104
         se leía perfectamente y a los 17 reales era **indistinguible de
         `document`**: el desgarro variaba un píxel. Es exactamente el fallo
         contra el que avisa la regla — comprobar a tres tamaños, y que mande
         el más pequeño. -->
    @case ('factura') {
      <path d="M5.2 3.5h7.6l4 4v13H5.2z" />
      <path d="M12.8 3.6v3.9h4" />
      <path d="M7.7 10.9h6.4" />
      <path d="M7.7 14.2h6.4v2.8H7.7z" fill="currentColor" stroke="none" />
    }
    @case ('calendar') {
      <rect x="4.25" y="6" width="15.5" height="13.75" rx="2" />
      <path d="M4.25 10.25h15.5M8.75 4.25V7.5M15.25 4.25V7.5" />
    }
    @case ('clock') {
      <circle cx="12" cy="12" r="8.25" />
      <path d="M12 7.25V12l3.25 2" />
    }
    <!-- Contenedor marítimo: corrugado y las dos barras de la puerta en el
         extremo derecho. El rectángulo con tres rayas que había antes servía
         igual para un contenedor que para una estantería. -->
    @case ('container') {
      <rect x="2.7" y="7.6" width="18.6" height="8.8" rx="1.2" />
      <path d="M6.9 7.6v8.8M10.8 7.6v8.8" />
      <path d="M14.7 7.6v8.8" />
      <path d="M17.3 10.1v3.8M19.1 10.1v3.8" />
      <path d="M6 16.4v1.5M18 16.4v1.5" />
    }
    @case ('truck') {
      <path d="M3.5 7.25a1.5 1.5 0 0 1 1.5-1.5h7.25v10.5H3.5z" />
      <path d="M12.25 9.5h3.6l3.15 3.3v3.45h-6.75z" />
      <circle cx="7.25" cy="17.75" r="1.9" />
      <circle cx="16.5" cy="17.75" r="1.9" />
    }

    <!-- ---- Programa de lealtad ----
         Familia propia. Lo que se mueve aquí no es carga sino puntos, así que
         la constante es el TOKEN —la moneda con su estrella— y lo que varía es
         en qué se convierte: una recompensa por canjear, un certificado ya
         emitido, o un colega al que se invita para ganarlos. -->

    <!-- Puntos: la ficha con la estrella sólida. La estrella va rellena porque
         a 17px un contorno de cinco puntas dentro de un círculo se cierra y se
         convierte en una mancha. La primera versión llevaba una segunda ficha
         detrás: a tamaño real sus dos trazos se fundían en un anillo doble y
         el icono pasaba a leerse como una medalla. -->
    @case ('puntos') {
      <circle cx="12" cy="12" r="8.4" />
      <path d="m12 6.9 1.62 3.28 3.62.53-2.62 2.55.62 3.6L12 15.16l-3.24 1.7.62-3.6L6.76 10.7l3.62-.53z" fill="currentColor" stroke="none" />
    }

    <!-- Recompensa: el cupón. Lo que lo separa del billete de `pronto-pago`
         —el otro rectángulo ancho del sistema— es la perforación del talón, no
         un adorno. Las muescas de la primera versión salían hacia fuera y a
         17px convertían el canto derecho en un bulto sólido. -->
    @case ('recompensa') {
      <rect x="2.6" y="6.6" width="18.8" height="10.8" rx="2.2" />
      <path d="M15.6 6.6v10.8" stroke-dasharray="2.1 1.9" />
      <path d="M6.1 10.7h6M6.1 13.6h3.8" />
    }

    <!-- Certificado: la hoja con el sello. `document` es cualquier documento;
         un certificado es el que va sellado, y el sello sólido es lo único que
         sobrevive a 17px. -->
    @case ('certificado') {
      <path d="M5.1 3.5h6l3.4 3.4v6.3a1.5 1.5 0 0 1-1.5 1.5H5.1a1.5 1.5 0 0 1-1.5-1.5V5a1.5 1.5 0 0 1 1.5-1.5z" />
      <path d="M10.9 3.6v3.4h3.5" />
      <circle cx="16.9" cy="16.5" r="2.5" fill="currentColor" stroke="none" />
      <path d="m15 18.6-.45 2.9 2.35-1.3 2.35 1.3-.45-2.9" />
    }

    <!-- Póliza: la unidad bajo la cobertura, porque lo que se asegura es la
         unidad. Toldo sólido: a 17px un arco hueco se funde, y es lo que lo
         separa de `truck`. Sin el asta el toldo flota y se lee como una nube. -->
    @case ('poliza') {
      <path d="M4.4 8.4a7.6 5 0 0 1 15.2 0z" fill="currentColor" />
      <path d="M12 3.4V2.4" />
      <path d="M12 8.4v1.9" />
      <path d="M3.6 13.3a1 1 0 0 1 1-1h8.3v5.6H3.6z" />
      <path d="M12.9 14.4h3.4l3.3 3v.5h-6.7" />
      <circle cx="7.2" cy="19.4" r="1.45" />
      <circle cx="16.4" cy="19.4" r="1.45" />
    }

    <!-- Invitar: el sobre y quien lo recibe. La invitación de este producto es
         literalmente un correo con tu enlace; un usuario con un signo de más
         serviría igual para dar de alta a un empleado. -->
    @case ('invitar') {
      <rect x="2.4" y="6.4" width="12.4" height="9.2" rx="1.6" />
      <path d="m2.9 7.4 5.7 4 5.7-4" />
      <circle cx="18.6" cy="13.8" r="2.05" />
      <path d="M15.3 19.9c0-1.9 1.5-3.2 3.3-3.2s3.3 1.3 3.3 3.2" />
    }

    <!-- ---- Puntos de la ruta ----
         Familia propia, no geometría prestada. En un viaje de drayage la
         constante es el contenedor; lo que cambia en cada punto es qué le pasa.
         Por eso los cuatro comparten la caja del contenedor o el lugar que la
         recibe, y se distinguen por la acción, no por un adorno.

         Presupuesto de detalle: se leen a 17px dentro del chip del encabezado
         de sección, así que ninguno pasa de nueve trazos. -->

    <!-- Origen: el contenedor SALE de aquí. Muelle, caja y flecha que se va. -->
    @case ('punto-origen') {
      <path d="M3.25 19.9h17.5" />
      <rect x="4.6" y="10.4" width="8.9" height="7.1" rx="1.1" />
      <path d="M9.05 10.4v7.1" />
      <path d="M17.9 17.5V7.9" />
      <path d="m15.5 10.3 2.4-2.4 2.4 2.4" />
    }

    <!-- Destino: el contenedor ENTRA aquí. Nave del destinatario y flecha que baja. -->
    @case ('punto-destino') {
      <path d="M3.4 10.15 12 5.1l8.6 5.05" />
      <path d="M5.7 10.9v8.9h12.6v-8.9" />
      <path d="M12 11.9v5.1" />
      <path d="m9.85 14.85 2.15 2.15 2.15-2.15" />
    }

    <!-- Retorno: el contenedor VUELVE al depósito. La caja abajo y el tramo de
         regreso arriba, separados: pegados se empastaban en un borrón a 17px. -->
    @case ('punto-retorno') {
      <rect x="3.4" y="12.6" width="17.2" height="6.5" rx="1.1" />
      <path d="M8.6 12.6v6.5M13.4 12.6v6.5" />
      <path d="M19 7.9H8.6" />
      <path d="m11.3 5.2-2.7 2.7 2.7 2.7" />
    }

    <!-- Parada intermedia: un nodo SOBRE la ruta, no un destino. El rombo manda y
         los dos tramos de ruta son contexto; con el rombo pequeño el icono
         desaparecía a 17px. El punto sólido le da peso a ese tamaño. -->
    @case ('punto-parada') {
      <path d="M12 2.9v3.3M12 17.8v3.3" />
      <path d="m12 7 4 5-4 5-4-5z" />
      <circle cx="12" cy="12" r="1.3" fill="currentColor" stroke="none" />
    }
    <!-- ---- Acciones del dominio ---- -->
    @case ('dollar-sign') {
      <path d="M12 4.25v15.5" />
      <path d="M15.75 8.15a3.4 3.4 0 0 0-3.4-2.15h-.9a3.05 3.05 0 0 0-.35 6.08l2.05.24a3.05 3.05 0 0 1-.35 6.08h-.9a3.4 3.4 0 0 1-3.4-2.15" />
    }
    <!-- Contraoferta: la tarifa publicada sale, y vuelve otra. Dos tramos, el de
         vuelta un poco más largo para que se lea como respuesta y no como
         sincronización.

         Se descartaron dos versiones con el signo de moneda —el arco de regreso
         sobre un `$`, y el `$` bajo una flecha— por dos razones medidas, no de
         gusto. A 17px, que es el tamaño real de este botón en la fila, el signo
         y el arco se empastaban en un borrón. Y el botón vecino en el mismo
         grupo es `dollar-sign`, el de cargos extra: dos glifos con el mismo
         signo a 32px eran indistinguibles justo donde hay que distinguirlos.
         El dinero lo pone la columna en la que vive; el icono pone el gesto. -->
    @case ('contraoferta') {
      <path d="M5.6 8.8h12.8" />
      <path d="m15.3 5.7 3.1 3.1-3.1 3.1" />
      <path d="M19.4 15.2H4.6" />
      <path d="m7.7 12.1-3.1 3.1 3.1 3.1" />
    }
    <!-- Fusionar duplicados: dos trazos paralelos que se juntan tangentes en
         uno. Sin vértice, que se leería como `chevron-right`, y sin nodos, que
         es lo que lo separa de `share`. -->
    @case ('fusionar') {
      <path d="M3.5 6.25c4.6 0 4.1 5.75 8.5 5.75" />
      <path d="M3.5 17.75c4.6 0 4.1-5.75 8.5-5.75" />
      <path d="M12 12h8.25" />
      <path d="m17 8.75 3.25 3.25L17 15.25" />
    }
    <!-- Conductor: el volante. Una silueta de persona a 17px es una mancha, y
         además no dice «conductor» sino «usuario»; el volante sí, y es el objeto
         que el transportista asocia con la figura del operador. -->
    @case ('conductor') {
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="2.6" />
      <path d="M12 3.5v5.9" />
      <path d="m6.55 16.4 3.2-2.5" />
      <path d="m17.45 16.4-3.2-2.5" />
    }

    <!-- ---- Adjuntos del flete ----
         Familia propia. Lo constante es la HOJA (o el marco); lo que varía es
         qué la convierte en esa prueba concreta. Un icono genérico de subida
         —una flecha entrando en una bandeja— sirve para cualquier archivo de
         cualquier producto: aquí lo que se adjunta tiene nombre en el dominio,
         así que se dibuja esa cosa.

         Presupuesto de trazo fijado por los 17px del hueco de la lista. -->

    <!-- Soltar archivo: la bandeja abierta y la hoja cayendo dentro. Es el
         estado «este hueco espera algo», no «pulsa para subir». -->
    @case ('soltar-archivo') {
      <path d="M4 14.25v3.25a1.75 1.75 0 0 0 1.75 1.75h12.5a1.75 1.75 0 0 0 1.75-1.75V14.25" />
      <path d="M12 3.75v8.5" />
      <path d="m8.6 8.9 3.4 3.35 3.4-3.35" />
    }
    <!-- Prueba de la entrega: la hoja firmada. La rúbrica es lo que la
         distingue de cualquier otro documento, y sobrevive a 17px porque cruza
         la hoja entera en vez de esconderse en una esquina. -->
    @case ('prueba-entrega') {
      <path d="M5.75 3.5h8.1l4.4 4.4V20.5H5.75z" />
      <path d="M13.6 3.6v4.5h4.5" />
      <path d="M8.1 17.9h8.4" />
      <path d="M8.6 15.9c1.4-2.9 2.4-2.9 2.9-1.4s1 2 1.9.7 1.6-.9 2.4.7" />
    }
    <!-- Foto en la entrega: el marco con su horizonte. Lo que se adjunta aquí es
         literalmente una foto, así que el marco es el dibujo correcto. -->
    @case ('foto-entrega') {
      <rect x="3.25" y="5.25" width="17.5" height="14" rx="2.25" />
      <circle cx="8.5" cy="10" r="1.5" fill="currentColor" stroke="none" />
      <path d="m3.6 17.3 4.6-4.5 3.4 3.2 3.3-3.7 5.8 5.6" />
    }
    <!-- Documento adicional: la hoja con el clip. El clip es lo que dice
         «anexo», no «documento del sistema». -->
    @case ('documento-adjunto') {
      <path d="M4.5 3.5h7.6l4.2 4.2V20.5H4.5z" />
      <path d="M11.9 3.6v4.2h4.2" />
      <path d="M20 11.3v5.6a3.2 3.2 0 0 1-6.4 0v-6.2a1.85 1.85 0 0 1 3.7 0v5.9a.75.75 0 0 1-1.5 0v-4.9" />
    }

    <!-- Pronto Pago: no es una estrella. Lo que distingue a esta tarifa es que
         el dinero llega antes, así que se dibuja el dinero (billete) y la
         velocidad (rayo sólido). El relleno del rayo es lo que lo salva a 17px,
         que es el tamaño al que vive, junto al importe. Antes eran dos glifos de
         Font Awesome anidados —`fa-star` con un `fa-usd` posicionado encima con
         `top`/`left` en píxeles—, que a cualquier otro tamaño se descuadraban. -->
    @case ('pronto-pago') {
      <rect x="2.75" y="6.25" width="18.5" height="11.5" rx="2.5" />
      <path d="M13.5 8.3 8.8 13.7h2.9l-.4 3.4 4.6-5.4h-2.9z" fill="currentColor" stroke="none" />
    }
    @case ('ban') {
      <circle cx="12" cy="12" r="8.25" />
      <path d="m6.15 6.15 11.7 11.7" />
    }
    @case ('share') {
      <circle cx="17.5" cy="6.25" r="2.5" />
      <circle cx="6.5" cy="12" r="2.5" />
      <circle cx="17.5" cy="17.75" r="2.5" />
      <path d="m8.75 10.8 6.5-3.3M8.75 13.2l6.5 3.3" />
    }
    <!-- Abrir en otra ventana. No es `share`, y la distinción importa: compartir
         es dar el destino a OTRO, y esto es ir uno mismo al destino sin perder
         de vista dónde estaba.

         La flecha **sale del panel**, y eso no es gusto: la primera versión la
         tenía entera dentro, y a los 13px del menú el glifo era un cuadrado con
         una mancha — el trazo interior no llegaba ni a dos píxeles y quedaba
         atrapado entre los cantos. Al romper la esquina superior derecha y
         llevar la punta fuera del cuerpo hay **dos siluetas** que distinguir en
         vez de una, que es lo único que sobrevive a ese tamaño; la comprobación
         fue rasterizar a 13 y ampliar, no mirar el SVG grande, donde las dos se
         leían igual de bien.

         Separarla del todo —panel pequeño abajo, flecha suelta arriba— se probó
         y se descartó: con aire entre las dos partes el glifo deja de decir
         «ventana» y se lee como el símbolo de Marte. El cruce con el canto es
         justamente lo que las ata. -->
    @case ('nueva-ventana') {
      <path d="M18.75 13.25v5.25a2 2 0 0 1-2 2H5.75a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2H11" />
      <path d="M14.75 3.5h5.75v5.75M10.25 13.75 20.5 3.5" />
    }
    @case ('bolt') {
      <path d="M13.25 3.5 6 13.25h4.75L10.75 20.5 18 10.75h-4.75z" />
    }
    <!-- Ver / ocultar: el par del campo de contraseña. Comparten el ojo y se
         distinguen por la barra, que es la convención que el usuario ya
         conoce; dibujarlos como dos glifos distintos rompería la lectura de
         «lo mismo, alternado». La barra va con el mismo trazo, no más fina:
         a 15px —el tamaño dentro de `.dxc-field__action`— una barra de 1 se
         perdía sobre el ojo. -->
    @case ('ver') {
      <path d="M2.4 12S6.1 5.75 12 5.75 21.6 12 21.6 12 17.9 18.25 12 18.25 2.4 12 2.4 12z" />
      <circle cx="12" cy="12" r="2.9" />
    }
    @case ('ocultar') {
      <path d="M9.6 6.15A8.7 8.7 0 0 1 12 5.75c5.9 0 9.6 6.25 9.6 6.25a17 17 0 0 1-3 3.75" />
      <path d="M6.3 8.05A17.2 17.2 0 0 0 2.4 12s3.7 6.25 9.6 6.25a8.9 8.9 0 0 0 3.4-.65" />
      <path d="M10.2 10.2a2.9 2.9 0 0 0 3.9 4.15" />
      <path d="m4.1 4.1 15.8 15.8" />
    }

    <!-- ---- Configuración de la cuenta ----
         Familia propia del hub de configuración. Lo constante es que cada
         icono nombra QUÉ se administra ahí —la empresa, quién entra, adónde
         va la carga, a quién le llega el correo—, no la acción de configurar.
         Un engrane repetido cinco veces no distingue nada.

         Presupuesto de trazo fijado por los 17px del chip; ninguno pasa de
         cinco elementos. -->

    <!-- Empresa: la fachada de oficinas con su anexo. No es la nave de
         `punto-destino` —esa tiene techo a dos aguas porque recibe carga—:
         esto es la entidad fiscal que timbra, así que se dibuja el edificio
         de plantas, con la entrada abajo. -->
    @case ('empresa') {
      <path d="M3.3 20.5h17.4" />
      <path d="M5.6 20.5V5.6a1.1 1.1 0 0 1 1.1-1.1h7a1.1 1.1 0 0 1 1.1 1.1v14.9" />
      <path d="M14.8 10.3h3.5a1.1 1.1 0 0 1 1.1 1.1v9.1" />
      <path d="M8.3 8.4h3.9M8.3 12.4h3.9" />
      <path d="M9.3 20.5v-2.7a.95.95 0 0 1 .95-.95h.5a.95.95 0 0 1 .95.95v2.7" />
    }

    <!-- Usuarios: dos siluetas. Aquí sí es la lectura correcta —la regla lo dice
         al descartarla para `conductor`: una silueta dice «usuario», y esto son
         exactamente los usuarios de la cuenta. La segunda va recortada para que
         se lea «varios» sin gastar trazo. -->
    @case ('usuarios') {
      <circle cx="9" cy="8.4" r="3.4" />
      <path d="M2.9 19.7a6.1 6.1 0 0 1 12.2 0" />
      <circle cx="17.4" cy="8.9" r="2.5" />
      <path d="M17.1 14.1a5.2 5.2 0 0 1 4 5.6" />
    }

    <!-- Domicilios de origen y destino: los dos extremos de un embarque. El nodo
         hueco es de donde sale, el pin es adonde llega, y el tramo entre ellos
         es lo que los convierte en una ruta y no en dos marcas sueltas. Un pin
         solo diría «mapa»; el par dice «origen y destino». -->
    @case ('domicilios') {
      <circle cx="4.9" cy="18.6" r="2.5" />
      <path d="M7.4 18.6h6.4a2.4 2.4 0 0 0 2.4-2.4v-1.5" />
      <path d="M16.2 3.5a3.9 3.9 0 0 1 3.9 3.9c0 2.9-3.9 7.3-3.9 7.3s-3.9-4.4-3.9-7.3a3.9 3.9 0 0 1 3.9-3.9z" />
      <circle cx="16.2" cy="7.4" r="1.35" fill="currentColor" stroke="none" />
    }

    <!-- Ajustes: los dos raíles con su tirador. El engrane era la salida fácil y
         además ya está gastada: sus cinco vecinos en el hub —empresa, usuarios,
         domicilios, correos, GPS— son todos objetos concretos, y un engrane
         encima de ellos no dice qué agrupa. Un panel de mandos sí: es
         literalmente lo que el hub es, y su silueta no se parece a ninguno de
         los cinco. Dos raíles y no tres: a tres, los tiradores quedan a 3.4px
         unos de otros a tamaño real y el icono se cierra. -->
    <!-- Dashboard: el tablero — un marco con tres barras que suben. Es lo que
         la pantalla es, un resumen de cifras, y a 17px tres trazos verticales
         dentro de un marco siguen leyéndose como gráfica. -->
    @case ('tablero') {
      <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
      <path d="M8 16.5v-3.5M12 16.5v-8M16 16.5v-5.5" />
    }

    @case ('ajustes') {
      <path d="M3.6 8.6h7.2M14.8 8.6h5.6" />
      <circle cx="12.8" cy="8.6" r="2.2" />
      <path d="M3.6 15.4h3.4M11 15.4h9.4" />
      <circle cx="9" cy="15.4" r="2.2" />
    }

    <!-- Correos: el sobre. Es el objeto literal —se configura a quién le llegan
         los correos—, y a 17px dos trazos sobreviven donde cinco no. -->
    @case ('correo') {
      <rect x="2.9" y="5.4" width="18.2" height="13.2" rx="2.2" />
      <path d="m3.7 7.5 7.2 5.1a2 2 0 0 0 2.2 0l7.2-5.1" />
    }

    <!-- ---- Chrome de la aplicación ---- -->
    <!-- Mensaje: la burbuja del chat del flete. Es de las pocas veces que el
         objeto genérico ES el objeto del dominio — un mensaje es un mensaje —,
         así que lo que hay que asegurar no es que sea específico sino que no se
         confunda con su vecino: la cola en el canto inferior izquierdo es lo
         único que a 17px lo separa de `document`, que también es una caja con
         dos renglones dentro. Por eso arranca en el borde y no insinuada. -->
    @case ('mensaje') {
      <path d="M7.5 4h10.75a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2H10l-4.5 3.4V6a2 2 0 0 1 2-2z" />
      <path d="M9 8.4h8M9 11.4h5" />
    }
    @case ('bell') {
      <path d="M12 4.25a5.25 5.25 0 0 0-5.25 5.25c0 4.2-1.5 5.4-1.5 5.4h13.5s-1.5-1.2-1.5-5.4A5.25 5.25 0 0 0 12 4.25z" />
      <path d="M10.4 18a1.85 1.85 0 0 0 3.2 0" />
    }
    <!-- Cerrar sesión. El anillo se abre porque el glifo estaba fuera de escala
         respecto a sus vecinos del mismo menú: medido sobre la caja de 16px, su
         tinta ocupaba 9.33px contra los 11.6 de `empresa` y los 11.2 de
         `ajustes`. Un 20 % menos en una columna de tres iconos no se lee como
         «otro icono», se lee como una fila mal alineada — y era el único
         desajuste real de ese menú. Ahora son 10.93, dentro de la familia.
         Solo se dibuja aquí, así que el ajuste no tiene más consumidores. -->
    @case ('power') {
      <path d="M12 3.5v8" />
      <path d="M6.9 6.2a8.2 8.2 0 1 0 10.2 0" />
    }
    <!-- Administración de la plataforma: el rack donde viven todas las empresas,
         no una entidad como `empresa`. Lo separa de `ajustes` el contorno cerrado
         de cada unidad y el piloto sólido frente al tirador hueco. -->
    @case ('administracion') {
      <rect x="3.5" y="3.75" width="17" height="6.75" rx="1.6" />
      <rect x="3.5" y="13.5" width="17" height="6.75" rx="1.6" />
      <circle cx="7.25" cy="7.12" r="1.25" fill="currentColor" stroke="none" />
      <circle cx="7.25" cy="16.88" r="1.25" fill="currentColor" stroke="none" />
      <path d="M11 7.12h6M11 16.88h6" />
    }

    <!-- ---- App móvil — contacto, ubicación y confianza ---- -->
    <!-- Teléfono: el auricular clásico en diagonal. Es genérico a propósito —no
         hay una cosa del dominio que dibujar para «llamar»— y se distingue de
         `mensaje` (burbuja) por la curva cerrada y los dos extremos gruesos. -->
    @case ('telefono') {
      <path d="M8.4 4H6.3A2.3 2.3 0 0 0 4 6.4 14.6 14.6 0 0 0 17.6 20a2.3 2.3 0 0 0 2.4-2.3v-2.1a1 1 0 0 0-.8-1l-3.3-.8a1 1 0 0 0-1 .3l-1.1 1.3a9.8 9.8 0 0 1-4.9-4.9l1.3-1.1a1 1 0 0 0 .3-1l-.8-3.3A1 1 0 0 0 8.4 4z" />
    }
    <!-- Pin: la gota con su hueco. Es el sitio SUELTO (una ubicación), no un
         punto de la ruta: lo separa de `punto-destino` que lleva el tramo. -->
    @case ('pin') {
      <path d="M12 21s-6.6-5.6-6.6-11.1a6.6 6.6 0 0 1 13.2 0C18.6 15.4 12 21 12 21z" />
      <circle cx="12" cy="9.9" r="2.4" />
    }
    <!-- Mi ubicación: la mira. Anillo, cuatro marcas hacia fuera y el punto
         sólido del centro — «aquí», no «allá», que es lo que dice `pin`. -->
    @case ('mi-ubicacion') {
      <circle cx="12" cy="12" r="6.25" />
      <circle cx="12" cy="12" r="1.9" fill="currentColor" stroke="none" />
      <path d="M12 2.75v3M12 18.25v3M2.75 12h3M18.25 12h3" />
    }
    <!-- Candado: cuerpo cerrado con el grillete arriba y el ojo sólido. -->
    @case ('candado') {
      <rect x="5" y="10.5" width="14" height="10" rx="2.2" />
      <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
      <circle cx="12" cy="15.5" r="1.3" fill="currentColor" stroke="none" />
    }
    <!-- Verificado: el escudo con la palomita. No es `check-circle` (una tarea
         hecha) sino «alguien comprobó esto»: la forma de escudo es lo que lo dice. -->
    @case ('escudo-check') {
      <path d="M12 3.25 5 5.9v5.4c0 4.2 2.9 7.7 7 9.45 4.1-1.75 7-5.25 7-9.45V5.9z" />
      <path d="m8.9 12.1 2.2 2.2 4-4.3" />
    }
    <!-- Filtro: el embudo. Los controles deslizantes se descartaron porque
         `ajustes` ya son dos raíles con su tirador. -->
    @case ('filtro') {
      <path d="M4 5.5h16l-6.1 7.4v5.3l-3.8 1.8v-7.1z" />
    }
    <!-- Estrella: cinco puntas, uniones redondas. De contorno es «sin valor»;
         con el relleno que pone `dxc-rating` es «con valor» — la forma lo dice. -->
    @case ('estrella') {
      <path d="M12 3l2.78 5.63 6.22.91-4.5 4.39 1.06 6.19L12 17.19l-5.56 2.93 1.06-6.19L3 9.54l6.22-.91z" />
    }

    @default {
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16.25V11.5" />
      <circle cx="12" cy="8" r="1" fill="currentColor" stroke="none" />
    }
  }
</svg>
